(function () {
  'use strict';

  if (window.PGCompleteSetDiscountBridgeV33) return;
  window.PGCompleteSetDiscountBridgeV33 = true;

  window.PGCompleteSetSettings = Object.assign({}, window.PGCompleteSetSettings || {}, {
    discountRate: 0.30,
    discountActive: true,
    discountCode: 'PGCOMPLETE30'
  });

  var upstreamFetch = window.fetch.bind(window);
  var code = 'PGCOMPLETE30';

  function root() {
    var value = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return value.charAt(value.length - 1) === '/' ? value : value + '/';
  }

  function requestUrl(input) {
    return typeof input === 'string' ? input : (input && input.url) || '';
  }

  function targetFromAdd(input, init) {
    if (!/\/cart\/add\.js(?:\?|$)/.test(requestUrl(input))) return null;
    var body = init && init.body;
    if (typeof body !== 'string' || body.indexOf('_pg_upsell_type') === -1) return null;
    try {
      var payload = JSON.parse(body);
      var item = payload && payload.items && payload.items.find(function (entry) {
        return entry && entry.id && entry.properties && entry.properties._pg_upsell_type;
      });
      if (!item) return null;
      return {
        variantId: String(item.id),
        artworkGroup: String(item.properties._pg_artwork_group || ''),
        upsellType: String(item.properties._pg_upsell_type || '')
      };
    } catch (error) {
      return null;
    }
  }

  function property(item, key) {
    return item && item.properties && item.properties[key] != null ? String(item.properties[key]) : '';
  }

  function targetLine(cart, target) {
    return (cart && cart.items || []).find(function (item) {
      if (String(item.variant_id || item.id || '') !== target.variantId) return false;
      if (!property(item, '_pg_upsell_type')) return false;
      if (target.upsellType && property(item, '_pg_upsell_type') !== target.upsellType) return false;
      if (target.artworkGroup && property(item, '_pg_artwork_group') !== target.artworkGroup) return false;
      return true;
    }) || null;
  }

  function verified(cart, target) {
    var line = targetLine(cart, target);
    if (!line) return false;
    var quantity = Math.max(1, Number(line.quantity || 1));
    var original = Number(line.original_line_price != null ? line.original_line_price : Number(line.price || 0) * quantity);
    var finalPrice = Number(line.final_line_price != null ? line.final_line_price : Number(line.final_price || line.price || 0) * quantity);
    return original > 0 && finalPrice > 0 && finalPrice <= Math.round(original * 0.70) + 1;
  }

  function activeCodes(cart) {
    var codes = (cart && cart.discount_codes || []).filter(function (entry) {
      return entry && entry.code && entry.applicable !== false && String(entry.code).toUpperCase() !== code;
    }).map(function (entry) { return String(entry.code); });
    codes.push(code);
    return codes.join(',');
  }

  function getCart() {
    return upstreamFetch(root() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('The cart could not be checked.');
      return response.json();
    });
  }

  function applyDiscount(cart) {
    return upstreamFetch(root() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        discount: activeCodes(cart),
        sections: ['header'],
        sections_url: window.location.pathname
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Shopify rejected the Complete the Set discount request.');
      return response.json();
    });
  }

  function fetchHeader() {
    var url = new URL(window.location.href);
    url.searchParams.set('sections', 'header');
    url.searchParams.set('pg_complete_set_v33', String(Date.now()));
    return upstreamFetch(url.pathname + url.search, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) return '';
      return response.json().then(function (sections) { return sections && sections.header || ''; });
    });
  }

  function wait(ms) {
    return new Promise(function (resolve) { window.setTimeout(resolve, ms); });
  }

  async function ensureDiscount(target) {
    for (var attempt = 0; attempt < 3; attempt += 1) {
      if (attempt) await wait(180 * attempt);
      var before = await getCart();
      var updated = await applyDiscount(before);
      if (verified(updated, target)) {
        return { cart: updated, header: updated.sections && updated.sections.header || await fetchHeader() };
      }
      var confirmed = await getCart();
      if (verified(confirmed, target)) {
        return { cart: confirmed, header: await fetchHeader() };
      }
    }
    throw new Error('The matching item was added, but the 30% Complete the Set discount could not be confirmed.');
  }


  /*
    A Complete the Set item only keeps its discount while its linked portrait remains
    in the cart. The link is stored when the add-on is created, so this check also
    covers a customer removing the portrait later from the full cart or mini cart.
  */
  function hasAppliedCompleteSetCode(cart) {
    return (cart && cart.discount_codes || []).some(function (entry) {
      return entry && entry.applicable !== false && String(entry.code || '').toUpperCase() === code;
    });
  }

  function sourceStillInCart(cart, upsellLine) {
    var sourceProduct = property(upsellLine, '_pg_source_product');
    var sourceVariant = property(upsellLine, '_pg_source_variant');
    return (cart && cart.items || []).some(function (item) {
      if (item === upsellLine || property(item, '_pg_upsell_type')) return false;
      if (sourceVariant && String(item.variant_id || item.id || '') === sourceVariant) return true;
      return Boolean(sourceProduct && String(item.product_id || '') === sourceProduct);
    });
  }

  function hasEligibleCompleteSetPair(cart) {
    return (cart && cart.items || []).some(function (item) {
      return Boolean(property(item, '_pg_upsell_type')) && sourceStillInCart(cart, item);
    });
  }

  function setCompleteSetCode(cart, include) {
    var codes = (cart && cart.discount_codes || []).filter(function (entry) {
      return entry && entry.code && String(entry.code).toUpperCase() !== code;
    }).map(function (entry) { return String(entry.code); });
    if (include) codes.push(code);
    return upstreamFetch(root() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (response) {
      if (!response.ok) throw new Error('Complete the Set eligibility could not be refreshed.');
      return response.json();
    });
  }

  function reconcileCompleteSetEligibility(cart) {
    if (!cart || !Array.isArray(cart.items)) return Promise.resolve(cart);
    var eligible = hasEligibleCompleteSetPair(cart);
    var applied = hasAppliedCompleteSetCode(cart);
    if (eligible === applied) return Promise.resolve(cart);
    return setCompleteSetCode(cart, eligible).catch(function (error) {
      console.warn('[Paw & Glory] Complete the Set eligibility refresh failed.', error);
      return cart;
    });
  }

  function setStatus(message, isError) {
    document.querySelectorAll('.pg-complete-set__discount-status').forEach(function (node) {
      node.textContent = message;
      node.classList.toggle('is-error', Boolean(isError));
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
    });
  }

  async function withHeader(addResponse, header) {
    if (!header || typeof Response !== 'function') return addResponse;
    var payload = await addResponse.clone().json().catch(function () { return null; });
    if (!payload || typeof payload !== 'object') return addResponse;
    payload.sections = Object.assign({}, payload.sections || {}, { header: header });
    var headers = new Headers(addResponse.headers);
    headers.delete('content-length');
    headers.set('content-type', 'application/json; charset=utf-8');
    return new Response(JSON.stringify(payload), {
      status: addResponse.status,
      statusText: addResponse.statusText,
      headers: headers
    });
  }

  document.addEventListener('pg:cart-synchronised', function (event) {
    reconcileCompleteSetEligibility(event && event.detail && event.detail.cart);
  });

  window.fetch = async function (input, init) {
    var target = targetFromAdd(input, init);
    if (!target) return upstreamFetch(input, init);

    var addResponse = await upstreamFetch(input, init);
    if (!addResponse.ok) return addResponse;

    try {
      var result = await ensureDiscount(target);
      var finalResponse = await withHeader(addResponse, result.header);
      setStatus('30% discount applied automatically in your cart.', false);
      document.dispatchEvent(new CustomEvent('pg:complete-set-discount-applied', {
        detail: {
          code: code,
          variantId: target.variantId,
          cart: result.cart,
          header: result.header
        }
      }));
      return finalResponse;
    } catch (error) {
      var message = error && error.message ? error.message : 'The 30% Complete the Set discount could not be applied.';
      console.error('[Paw & Glory] Complete the Set discount verification failed.', error);
      setStatus(message, true);
      document.dispatchEvent(new CustomEvent('pg:complete-set-discount-error', {
        detail: { code: code, variantId: target.variantId, message: message }
      }));
      return addResponse;
    }
  };
})();
